import React from "react"
import PropTypes from "prop-types"

import Markdown from "@components/Markdown"

const TrustyCardModule = ({ children }) => {
  return (
    <div
      className="flex justify-center bg-gradient-to-r
       from-lblue to-lblue bg-mgrey py-7 px-6 md:py-10 xl:p-25"
    >
      <div
        className="prose md:max-w-[600px] 
        xl:max-w-[980px] prose-p:text-16 xl:prose-p:text-[24px] 
      prose-p:font-inter prose-p:font-normal 
      prose-p:leading-6 xl:prose-p:leading-150%
       prose-p:text-dblue"
      >
        <Markdown>{children}</Markdown>
      </div>
    </div>
  )
}

TrustyCardModule.propTypes = {
  children: PropTypes.node,
}

export default TrustyCardModule
